const { apiAdapter } = require("./ApiAdapter");

const getCustomer = (params) => {
  return apiAdapter({
    url: "customer",
    method: "GET",
    params,
  });
};
const getCustomerList = () => {
  return apiAdapter({
    url: "customer/list",
    method: "GET",
  });
};
const getCustomerListWithQuotation = (params) => {
  return apiAdapter({
    url: "/customer/list/quotation",
    method: "GET",
    params,
  });
};

const createCustomer = (data) => {
  return apiAdapter({
    url: "customer/create",
    method: "POST",
    data,
  });
};
const updateCustomer = (data) => {
  return apiAdapter({
    url: "customer/update",
    method: "PUT",
    data,
  });
};
const deleteCustomer = (data) => {
  return apiAdapter({
    url: "customer/delete",
    method: "DELETE",
    data,
  });
};

module.exports = {
  getCustomer,
  getCustomerList,
  createCustomer,
  updateCustomer,
  deleteCustomer,
  getCustomerListWithQuotation,
};
